import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

export default createStore({
  state: {
    cCode: 0, // 初期状態
    bookmark: false,
  },
  getters: {},
  mutations: {
    // `cCode` の値を変更するミューテーション
    cCode(state, code) {
      state.cCode = code;
    },
    bookmark(state, bm) {
      state.bookmark = bm;
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      // 保存先を指定（デフォルトでは `localStorage` ですが、`sessionStorage` に変更も可能）
      storage: window.localStorage,
    }),
  ],
});
